
import {QueryCommand,AssertUtils} from "goingutils";
import WinUtils from "../../winUtils";


let FileUtils = {
    loadFilesByFileIds(relFileId,backFun){
        if(AssertUtils.isNotEmpty(relFileId)){
            let queryCommand = new QueryCommand("/go-framework/document/read_by_ids/" + relFileId);
            queryCommand.executeQuery(
                {},
                datas => backFun(datas),
                function () {
                },
                "json"
            );
        }
    },
    loadFilesByBid(relFileId,backFun){
        if(AssertUtils.isNotEmpty(relFileId)){
            let queryCommand = new QueryCommand("/go-framework/document/readByDocBid/" + relFileId);
            queryCommand.executeQuery(
                {},
                datas => backFun(datas),
                function () {
                },
                "json"
            );
        }
    },
    delFile: function (fileId, successFun) {
        if (AssertUtils.isNotEmpty(fileId)) {
            let queryCommand = new QueryCommand({url:`${window.SysConfigUtils.go_eplat_adress}${window.projectName.file}/attachment/delete/` +fileId});
            queryCommand.executeQuery({successFun});
        }
    },
    showFileUploadWin: function ({url, params, title = "选择导入的Excel"}) {
        WinUtils.showInfoOnWin({
            width: 550,
            height: 350,
            url: url,
            params: params,
            showBottomBar: true,
            title: title,
            confirmBtn: function () {
            },
            anim: null
        });
    }
};

export default FileUtils;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/utils/FileUtils.js